<script>
import RecycleModal from './RecycleModal.vue'
import Accordion from '../../Accordion.vue'
import AccordionItem from '../../AccordionItem.vue'
import LoadingCvPersonalDetails from '../Applicant/LoadingCV/PersonalDetails.vue'
import LoadingCvAims from '../Applicant/LoadingCV/Aims.vue'
import StarRating from 'vue-star-rating'
import FailModal from './FailModal.vue'
import CheckIdInfoModal from './CheckIdInfoModal.vue'
import Cv from './LoadingCV/Cv.vue'
import moment from 'moment'
import ComponentStarRating from '../../ComponentStarRating.vue'

export default {
    components: {
        RecycleModal,
        Accordion,
        AccordionItem,
        LoadingCvPersonalDetails,
        LoadingCvAims,
        StarRating,
        FailModal,
        Cv,
        ComponentStarRating,
        CheckIdInfoModal
    },
    props: {
        jobApplication: {
            type: Object|Array,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        module: {
            type: Object|Array,
            required: true
        },
        traitStatementsByCluster: {
            type: Object|Array,
            required: true
        },
        interviewAnswers: {
            type: Object|Array,
            required: true
        },
        interviewScores: {
            type: Object|Array,
            required: true
        },
        logs: {
            type: Object|Array,
            required: false
        },
        idVerificationCheck: {
            type: Object|Array,
            required: false
        },
    },
    data() {
        return {
            average: 0,
            rating: [],
            fail_reason: '',
            passBtnDisabled: false,
            telephonic_screening_status: this.jobApplication.telephonic_screening_status,
            atsType: this.jobApplication.job.requisition.person_specification.ats_type,
            disabled: false,
            lastSavedAnswers: {},
            lastSavedScores: {}
        }
    },
    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        sliceString(value) {
            return value.substring(value.lastIndexOf("/") + 1)
        },
        changeRatingValue(key, value) {
            this.rating[key] = parseInt(value);
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        convertDate(date, format = 'YYYY-MM-DDThh:mm') {
            return moment.parseZone(date).format(format)
        },
        setRating: function(rating){
            this.rating = parseInt(rating);
        },
        disablePassBtn() {
            this.passBtnDisabled = true;
            this.telephonic_screening_status = 'passed';
        },
        startAutoSave() {
            this._autoSaveInterval = setInterval(() => {
                let updatedAnswers = {};

                // Group radio inputs by question index
                let radioGroups = {};
                document.querySelectorAll('[name^="interview_answers\\["][name$="\\[answer\\]"]')
                    .forEach(input => {
                        const nameParts = input.name.match(/^interview_answers\[(\d+)\]\[answer\]$/);
                        if (nameParts) {
                            const index = nameParts[1];
                            if (!radioGroups[index]) radioGroups[index] = [];
                            if (input.type === 'radio') {
                                radioGroups[index].push(input);
                            }
                        }
                    });

                document.querySelectorAll('[name^="interview_answers\\["][name$="\\[answer\\]"]').forEach(input => {
                    const nameParts = input.name.match(/^interview_answers\[(\d+)\]\[answer\]$/);
                    if (nameParts) {
                        const index = nameParts[1];
                        const jobApplicationId = document.querySelector(`[name="interview_answers[${index}][job_application_id]"]`).value;
                        const interviewQuestionId = document.querySelector(`[name="interview_answers[${index}][interview_question_id]"]`).value;
                        let answer = null;

                        if (input.type === 'radio') {
                            // Only process the first radio in the group
                            if (radioGroups[index] && radioGroups[index][0] === input) {
                                const checkedRadio = radioGroups[index].find(r => r.checked);
                                answer = checkedRadio ? checkedRadio.value : null;
                            } else {
                                return; // skip, already processed
                            }
                        } else {
                            answer = input.value;
                        }

                        if (jobApplicationId && interviewQuestionId !== undefined) {
                            updatedAnswers[index] = {
                                job_application_id: jobApplicationId,
                                interview_question_id: interviewQuestionId,
                                answer: answer
                            };
                        }
                    }
                });

                // Compare with last saved answers
                if (JSON.stringify(updatedAnswers) !== JSON.stringify(this.lastSavedAnswers)) {
                    this.saveInterviewAnswers(updatedAnswers);
                    this.lastSavedAnswers = updatedAnswers; // Update stored answers
                }

            }, 3000);
        },
        saveInterviewAnswers(updatedAnswers, showFlash = false) {
            if (Object.keys(updatedAnswers).length === 0 && JSON.stringify(updatedAnswers) === JSON.stringify(this.lastSavedAnswers)) {
                console.log("No changes detected, no need to save.");
                return;
            }
            axios.post('/recruiter/active-requisitions/save-interview-answers', {
                answers: updatedAnswers,
                job_application_id: this.jobApplication.id,
            });
            if (showFlash) {
                this.showFlashMessages('Interview answers saved successfully.', 'success');
            }
        },
        saveInterviewScores() {
            let interviewScores = {
                id: this.interviewScores['Telephonic Screening'] ? this.interviewScores['Telephonic Screening']['id'] : null,
                phase: 'Telephonic Screening',
            };

            const telephonicScreening = document.querySelector('.telephonic-screening');
            if (telephonicScreening) {
                telephonicScreening.querySelectorAll('[name^="interview_scores\\[0\\]\\["][name$="\\]"]').forEach(input => {
                    const nameParts = input.name.match(/^interview_scores\[0\]\[(.+)\]$/);
                    if (nameParts) {
                        const key = nameParts[1];
                        interviewScores[key] = input.value;
                    }
                });
            }

            if (Object.keys(interviewScores).length === 0 || JSON.stringify(interviewScores) === JSON.stringify(this.lastSavedScores)) {
                console.log("No changes detected, no need to save.");
                return;
            }

            axios.post('/recruiter/active-requisitions/save-interview-answers', {
                interview_scores: interviewScores,
                job_application_id: this.jobApplication.id,
            });

            this.lastSavedScores = interviewScores; // Update stored scores
        },
        startAutoSaveScores() {
            this._autoSaveScoresInterval = setInterval(() => {
                this.saveInterviewScores();
            }, 3000);
        },
        saveInterviewAnswersManual() {
            let updatedAnswers = {};
            let radioGroups = {};
            document.querySelectorAll('[name^="interview_answers\\["][name$="\\[answer\\]"]')
                .forEach(input => {
                    const nameParts = input.name.match(/^interview_answers\[(\d+)\]\[answer\]$/);
                    if (nameParts) {
                        const index = nameParts[1];
                        if (!radioGroups[index]) radioGroups[index] = [];
                        if (input.type === 'radio') {
                            radioGroups[index].push(input);
                        }
                    }
                });

            document.querySelectorAll('[name^="interview_answers\\["][name$="\\[answer\\]"]').forEach(input => {
                const nameParts = input.name.match(/^interview_answers\[(\d+)\]\[answer\]$/);
                if (nameParts) {
                    const index = nameParts[1];
                    const jobApplicationId = document.querySelector(`[name="interview_answers[${index}][job_application_id]"]`).value;
                    const interviewQuestionId = document.querySelector(`[name="interview_answers[${index}][interview_question_id]"]`).value;
                    let answer = '';

                    if (input.type === 'radio') {
                        if (radioGroups[index] && radioGroups[index][0] === input) {
                            const checkedRadio = radioGroups[index].find(r => r.checked);
                            answer = checkedRadio ? checkedRadio.value : '';
                        }
                    } else {
                        answer = input.value;
                    }

                    if (jobApplicationId && interviewQuestionId !== undefined) {
                        updatedAnswers[index] = {
                            job_application_id: jobApplicationId,
                            interview_question_id: interviewQuestionId,
                            answer: answer
                        };
                    }
                }
            });

            this.saveInterviewScores();
            this.saveInterviewAnswers(updatedAnswers, true);
            this.lastSavedAnswers = updatedAnswers;
        },
        showFlashMessages(message = 'Oops, something went wrong.', type = 'warning') {
            let $flash = $(`
                <div id="flash-message-container"  data-component="flashMessages" onclick="this.classList.add('hide')">
                    <div class="${type} callout block"><div class="message">${message} <i class="fas fa-times pointer"></i></div></div>
                </div>
            `);
            $('body').append($flash);
        },
        pass(value) {
            this.telephonic_screening_status = 'passed';

            this.$nextTick(() => {
                this.$refs.passedButton.click();
            });
        },
    },
    mounted() {
        if (this.jobApplication.telephonic_screening_status == 'passed') {
            this.passBtnDisabled = true;
        }

        if (this.atsType == 'leadership_and_support') {
            this.disabled = ( this.jobApplication.killer_question_status === null || this.jobApplication.killer_question_status === '') ? true : false;
        } else {
            this.disabled = ( this.jobApplication.language_proficiency_status === null || this.jobApplication.language_proficiency_status === '') ? true : false;
        }

        // Auto save disabled as requested
        this.startAutoSave();
        this.startAutoSaveScores();
    },
    beforeDestroy() {
        // Stop any running intervals from startAutoSave and startAutoSaveScores
        if (this._autoSaveScoresInterval) clearInterval(this._autoSaveScoresInterval);
    },
    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.telephonic_screening_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    },
}
</script>
<template>
    <div class="telephonic-screening">
        <div class="grid-x grid-padding-x">
            <div class="cell small-6" style="border-right: solid 1px #D1D1D1; padding: 30px 35px">
                <div style="width:90%">
                    <strong>Invite candidate to a telephonic interview:</strong>
                    <p>Pick three timeslots that the candidate will be able to pick from</p>
                    <form action="" method="post" class="pt-0 mt-2">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <div class="form-control px-0">
                            <label>Option 1</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="telephonic_screening_result[date_first]"
                                required
                                :value="(jobApplication.telephonic_screening_result) ? convertDate(jobApplication.telephonic_screening_result.date_first) : convertDate(this.value)"
                            />
                        </div>

                        <div class="form-control px-0">
                            <label>Option 2</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="telephonic_screening_result[date_second]"
                                required
                                :value="(jobApplication.telephonic_screening_result) ? convertDate(jobApplication.telephonic_screening_result.date_second) : convertDate(this.value)"
                            />
                        </div>

                        <div class="form-control px-0">
                            <label>Option 3</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="telephonic_screening_result[date_third]"
                                required
                                :value="(jobApplication.telephonic_screening_result) ? convertDate(jobApplication.telephonic_screening_result.date_third) : convertDate(this.value)"
                            />
                        </div>
                        <button :disabled="disabled" class="button mt-2" name="telephonic_screening" type="submit">Send Invite</button>
                    </form>
                    <form action="" method="post" class="pt-0 mt-2">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <div class="form-control px-0">
                            <label>Set date and time manually</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="telephonic_screening_result[date_first]"
                                required
                                :value="(jobApplication.telephonic_screening_result) ? convertDate(jobApplication.telephonic_screening_result.date_first) : convertDate(this.value)"
                            />
                        </div>
                        <button :disabled="disabled" class="button mt-2" name="telephonic_screening_manually" type="submit">Set time manually</button>
                    </form>
                    <br />
                    <Cv
                        :jobApplication="jobApplication"
                        :module="module"
                        div-class="small-10"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                    />
                </div>
            </div>
            <div class="cell small-6 p-4">
                <form method="post" v-on:submit="disablePassBtn">
                    <input type="hidden" name="_csrfToken" :value="csrfToken" />
                    <input type="hidden" name="fail_reason" :value="fail_reason" />
                    <input type="hidden" name="telephonic_screening_status" :value="telephonic_screening_status">

                    <h4>Invitation</h4>
                    <div v-if="jobApplication.telephonic_screening_result">
                        <strong>Invitation Status:</strong> {{ (jobApplication.telephonic_screening_result.status === 'reschedule') ? 'The candidate is not available.  Please resend a new invitation.' : jobApplication.telephonic_screening_result.status}}
                        <br>
                        <strong>Date and Time Scheduled:</strong> {{ jobApplication.telephonic_screening_result.date_selected ? convertDate(jobApplication.telephonic_screening_result.date_selected, 'MMMM D, YYYY H:mm') : '' }}
                        <br>
                    </div>
                    <div v-else>
                        <strong>Invitation Status:</strong> Not yet sent
                        <br>
                        <strong>Date and Time Scheduled:</strong> Not yet set
                        <br>
                    </div>
                    <strong>Final Status:</strong> {{ jobApplication.telephonic_screening_status }}
                    <span v-if="logs !== null && logs !== ''">
                        &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created, 'YYYY-MM-DD HH:mm') }})
                    </span>

                    <div class="grid-x grid-padding-x">
                        <div class="cell shrink">
                            <div v-if="jobApplication.user.country_id === 246">
                                <button :class="{'d-none': idVerificationCheck === null}" class="button px-5" ref="passedButton" type="submit" :disabled="passBtnDisabled || disabled">Pass</button>
                                <button :class="{'d-none': idVerificationCheck !== null}" :disabled="disabled" class="button px-5" type="button" @click="toggleModal('checkIdInfoModal')">Pass</button>
                            </div>
                            <div v-else>
                                <button class="button px-5" ref="passedButton" type="submit" :disabled="passBtnDisabled || disabled">Pass</button>
                            </div>
                        </div>
                        <div>
                            <button class="d-none" value="failed" ref="failedButton"
                                name="telephonic_screening_status"></button>
                            <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                        </div>
                        <div class="cell shrink">
                            <button :disabled="disabled" class="button recycle px-5" type="button"
                                @click="toggleModal('recycleModal')">Recycle</button>
                        </div>
                    </div>
                    <hr>
                    <h4 class="mt-4">Screening Questions</h4>
                    <div v-for="(interviewQuestion, index) in jobApplication.job.requisition.person_specification.interview_questions" :key="'row'+index">
                        <div v-if="interviewQuestion.phase == 'Telephonic Screening'">
                            <!-- <input type="hidden" :name="`language_proficiency_scores[${i}][id]`" :value="langProf.id" /> -->
                            <input type="hidden" :name="`interview_answers[${index}][job_application_id]`"
                                :value="jobApplication.id" />
                            <input type="hidden" :name="`interview_answers[${index}][interview_question_id]`"
                                :value="interviewQuestion.id" />

                            <div v-if="interviewAnswers[interviewQuestion.id]">
                                <input type="hidden" :name="`interview_answers[${index}][id]`"
                                    :value="interviewAnswers[interviewQuestion.id]['id']" />
                            </div>

                            <div class="d-flex align-items-center gap-1">
                                <p><strong>{{ index + 1 }}. </strong></p> <span v-html="interviewQuestion.title"></span>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'yes_no'">
                                <input :disabled="disabled" type="radio" value="1" :name="`interview_answers[${index}][answer]`"
                                    :checked="(interviewAnswers[interviewQuestion.id] && interviewAnswers[interviewQuestion.id]['answer'] == 1)">

                                <label>
                                    Yes
                                </label>

                                <input :disabled="disabled" type="radio" value="0" :name="`interview_answers[${index}][answer]`"
                                    :checked="(interviewAnswers[interviewQuestion.id] && interviewAnswers[interviewQuestion.id]['answer'] == 0)">

                                <label>
                                    No
                                </label>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'free'">
                                <textarea v-if="interviewAnswers[interviewQuestion.id]" rows="40" :disabled="disabled" :name="`interview_answers[${index}][answer]`" v-model="interviewAnswers[interviewQuestion.id]['answer']"></textarea>
                                <textarea v-else rows="40" :disabled="disabled" :name="`interview_answers[${index}][answer]`"></textarea>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'rating'">
                                <component-star-rating
                                    :disabled="disabled"
                                    :name="`interview_answers[${index}][answer]`"
                                    :default-rating="parseInt(interviewAnswers[interviewQuestion.id] ? interviewAnswers[interviewQuestion.id]['answer'] : 0)"
                                ></component-star-rating>
                            </div>
                            <br>
                        </div>
                    </div>

                    <input type="hidden" name="interview_scores[0][job_application_id]`" :value="jobApplication.id" />
                    <input type="hidden" name="interview_scores[0][phase]`" value="Telephonic Screening" />
                    <input type="hidden" name="interview_scores[0][id]`" :value="interviewScores['Telephonic Screening'] ? interviewScores['Telephonic Screening']['id'] : null" />
                    <div class="form-control">
                        <label>Pitch:</label>
                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][pitch]"
                            :value="interviewScores['Telephonic Screening'] ? interviewScores['Telephonic Screening']['pitch'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Pace:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][pace]"
                            :value="interviewScores['Telephonic Screening'] ? interviewScores['Telephonic Screening']['pace'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Tone:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][tone]"
                            :value="interviewScores['Telephonic Screening'] ? interviewScores['Telephonic Screening']['tone'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Clarity:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][clarity]"
                            :value="interviewScores['Telephonic Screening'] ? interviewScores['Telephonic Screening']['clarity'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Score:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][score]"
                            :value="interviewScores['Telephonic Screening'] ? interviewScores['Telephonic Screening']['score'] : 0"
                        />
                    </div>

                    <div class="form-control">
                        <div class="grid-x grid-padding-x">
                            <div class="cell shrink">
                                <div v-if="jobApplication.user.country_id === 246">
                                    <button
                                        :disabled="disabled"
                                        ref="passedButton"
                                        class="button px-5"
                                        :class="{'d-none': idVerificationCheck === null}"
                                        type="submit"
                                        name="telephonic_screening_status"
                                        value="passed"
                                    >
                                        Pass
                                    </button>
                                    <button
                                        :disabled="disabled"
                                        :class="{'d-none': idVerificationCheck !== null}"
                                        class="button px-5"
                                        type="button"
                                        @click="toggleModal('checkIdInfoModal')"
                                        value="passed"
                                    >
                                        Pass
                                    </button>
                                </div>
                                <div v-else>
                                    <button
                                        :disabled="disabled"
                                        ref="passedButton"
                                        class="button px-5"
                                        type="submit"
                                        name="telephonic_screening_status"
                                        value="passed"
                                    >
                                        Pass
                                    </button>
                                </div>
                            </div>
                            <div>
                                <button class="d-none" value="failed" ref="failedButton"
                                    name="telephonic_screening_status"></button>
                                <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                            </div>
                            <div class="cell shrink">
                                <button :disabled="disabled" class="button recycle px-5" type="button"
                                    @click="toggleModal('recycleModal')">Recycle</button>
                            </div>
                            <div class="cell shrink">
                                <button type="button" @click="saveInterviewAnswersManual()" class="button">Save Interview Answers</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
            <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
            <check-id-info-modal ref="checkIdInfoModal" @submit="pass" :job-application="jobApplication" />
        </div>
    </div>
</template>